import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { MAX_FILE_SIZE } from '@pt/constants';
import { RootState } from '@pt/store';
import {
  ButtonModule,
  DialogRef,
  IconModule,
  SpinnerModule,
  TextAreaComponentModule,
  UploaderModule,
} from '@hglobal/common';
import { FormType, SupportContact } from '@pt/models';
import { environment } from '@pt/environment';
import { GoogleAnalyticsService } from '@pt/services';
import { asyncScheduler } from 'rxjs';

import { SupportActions } from '../../store';

@Component({
  selector: 'pu-support-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    SpinnerModule,
    ButtonModule,
    IconModule,
    TextAreaComponentModule,
    SpinnerModule,
    UploaderModule,
  ],
})
export class ContactComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef);
  readonly #googleAnalyticsService = inject(GoogleAnalyticsService);

  readonly MAX_FILE_SIZE = MAX_FILE_SIZE;

  assetsHost = environment.assetsHost;
  form: FormType<SupportContact>;
  isLoading = false;
  isClickInProgress = false;

  constructor(
    private _store: Store<RootState>,
    private _actionsSubject: ActionsSubject,
    private _fb: FormBuilder,
    private _dialogRef: DialogRef,
  ) {
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      text: ['', Validators.required],
      images: [<any>[]],
    });

    this._actionsSubject.pipe(
      ofType(SupportActions.sendMessageReq.succeededAction),
      takeUntilDestroyed(this.#destroyRef),
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this._dialogRef.close();
      },
    });

    this.#googleAnalyticsService.pushCustomEvent('contact_support', 'open');
  }

  send(): void {
    this.isLoading = true;
    this._store.dispatch(SupportActions.sendMessageReq.action({
      payload: { ...(<any> this.form.value) },
    }));
  }

  cancel(closedByIcon = false): void {
    this._dialogRef.close();

    this.#googleAnalyticsService.pushCustomEvent(
      'contact_support',
      closedByIcon ? 'close' : 'cancel_button',
    );
  }

  clickOnBrowserImage(): void {
    if (!this.isClickInProgress) {
      this.#googleAnalyticsService.pushCustomEvent('contact_support', 'browse_image_button');
      this.isClickInProgress = true;
    }

    asyncScheduler.schedule(() => {
      this.isClickInProgress = false;
    });
  }
}
